import styled from 'styled-components';
import { media } from '@/styles/Qtheme.ts';

export const SectionHeaderContainer = styled.div`
  display: flex;
  height: 200px;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  max-width: 1200px;
  margin-bottom: 65px;

  @media ${media.desktop} {
    height: auto;
    margin-bottom: 0;
  }
`;

export const SectionHeaderTextWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  font-family: 'Pretendard', sans-serif;

  @media ${media.desktop} {
    width: 100%;
    align-items: center;
    margin-top: 36px;
    margin-bottom: 36px;
  }
`;
export const SectionHeaderTitle = styled.div`
  font-size: 34px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  color: ${({ theme }) => theme.COLORS.itemTitle};

  @media ${media.mobile} {
    font-size: 26px;
  }
`;
export const SectionHeaderDesc = styled.div`
  color: ${({ theme }) => theme.COLORS.descText};
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px; /* 146.667% */
  white-space: pre-line;
  text-align: left;

  @media ${media.mobile} {
    font-size: 13px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px; /* 138.462% */
  }
`;

export const SectionHeaderImage = styled.div`
  width: 308.194px;
  height: 200px;
`;

export const CommonTableContainerWrap = styled.div`
  display: flex;
  width: 1200px;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;

  @media ${media.mobile} {
    width: 100%;
    padding: 16px;
    padding-top: 0;
  }
`;
export const CommonTableContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;
  font-family: 'Pretendard', sans-serif;
`;

export const CommonTableHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;

  @media ${media.desktop} {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }
`;
export const CommonTableTitle = styled.div`
  color: ${({ theme }) => theme.COLORS.itemTitle};
  font-size: 30px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;

  @media ${media.desktop} {
    font-size: 24px;
  }
`;
export const CommonTableSearchBar = styled.div`
  display: flex;
  width: 200px;
  height: 36px;
  align-items: center;
  gap: 6px;

  @media ${media.desktop} {
    width: 100%;
  }
`;

export const CommonTableContent = styled.div`
  display: flex;
  padding: 20px 24px 24px 24px;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  align-self: stretch;

  border-radius: 12px;
  background: ${({ theme }) => theme.COLORS.tableBg};

  @media ${media.desktop} {
    overflow-x: auto; // 가로 스크롤 활성화
    width: 100%; // 부모 요소에 맞게 너비 설정
  }
`;
export const CommonTableContentHead = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  align-self: stretch;
  font-family: 'Pretendard', sans-serif;

  @media ${media.desktop} {
    width: auto;
  }
`;
export const CommonTableContentHeadRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;

  @media ${media.desktop} {
    width: 100%;
  }
`;
export const CommonTableContentHeadCell = styled.div`
  color: ${({ theme }) => theme.COLORS.itemContent};
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;

  @media ${media.desktop} {
    flex: 1; // 셀을 균등하게 배분
    min-width: 105px; // 최소 너비 설정
  }
`;

export const CommonTableContentRowWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;

  @media ${media.desktop} {
    width: 100%;
  }
`;
export const CommonTableContentRow = styled.div`
  display: flex;
  width: 1152px;
  padding: 10px 0px;
  justify-content: space-between;
  align-items: center;

  @media ${media.desktop} {
    width: 100%;
  }
`;
export const CommonTableContentCell = styled.div`
  color: ${({ theme }) => theme.COLORS.itemTitle};
  text-align: right;
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  font-family: 'Pretendard', sans-serif;
  display: flex;
  width: 190px;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;

  @media ${media.desktop} {
    flex: 1; // 셀을 균등하게 배분
    min-width: 105px; // 최소 너비 설정
    flex-shrink: 0; // 셀 크기가 줄어들지 않도록 설정
  }
`;
export const CommonTableContentCellText = styled.div`
  color: ${({ theme }) => theme.COLORS.itemTitle};
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`;
export const CommonTableContentCellIcon = styled.div`
  flex-shrink: 0;
`;
export const CommonTableContentCellSub = styled.div`
  color: ${({ theme }) => theme.COLORS.itemContent};
`;

export const CommonSearch = styled.div`
  width: 100%;
  position: relative;
  background-color: ${({ theme }) => theme.COLORS.PrimaryInputBg};
  height: 36px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 10px 12px;
  box-sizing: border-box;
  gap: 6px;
  text-align: left;
  font-size: 14px;
  color: ${({ theme }) => theme.COLORS.searchText};
  font-family: 'Pretendard', sans-serif;
`;
export const CommonSearchInput = styled.input`
  position: relative;
  width: 100%;
  background-color: ${({ theme }) => theme.COLORS.PrimaryInputBg};
  font-size: 16px;
  border-radius: 5px;
  border: none;
  box-shadow: 0 0 0 0;
  outline: none;
  color: ${({ theme }) => theme.COLORS.itemTitle};

  @media ${media.desktop} {
    font-size: 14px;
  }
`;
export const CommonSearchIcon = styled.div`
  width: 18px;
  position: relative;
  height: 18px;
`;

export const CommonPagination = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 16px;
  align-self: stretch;
  font-family: 'Pretendard', sans-serif;
  flex-direction: row;

  @media ${media.desktop} {
    justify-content: center;
  }
`;
export const CommonPaginationButtonWrap = styled.div`
  justify-content: center;
  align-items: center;
  gap: 10px;
  display: flex;
  flex-direction: row;
`;
export const CommonPaginationButton = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== 'active',
})<{ active?: boolean }>`
  width: 27px;
  padding: 5px 8px;
  border-radius: 2px;
  text-align: center;
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  cursor: pointer;
  color: ${({ theme, active }) =>
    active ? theme.COLORS.itemTitle : theme.COLORS.tabMenuInactive};
  background-color: ${({ theme, active }) =>
    active ? theme.COLORS.listIconBorder : 'none'};
`;
export const CommonPaginationButtonActive = styled.div``;

export const CommonPaginationArrow = styled.div`
  cursor: pointer;
  display: flex;
  width: 16px;
  height: 16px;
`;
